export default __webpack_public_path__ + "pi1-1QAAT/components/SocialProof/images/income-ease-016aba71b3e0319c47a9e2de7a882a10.svg";